/**
 *      Arquivo responsável por guardar todos os end-point que serão requisitados
 *          pelo módulo
 */

export default {
   putLattes: { method: 'put', url: 'api/secure/student/student/lattes/{academic_code}' }
}